import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/auth'

export default {
  login(email, password) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/login`, {
      email,
      password,
      type_login: 'admin',
    })
  },
  refreshToken() {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/refresh`)
  },
  me() {
    return axios.post(config.webApiBase + RESOURCE_NAME + '/me')
  },
  recoverPassword(username) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/password/reset-link`, {
      username,
    })
  },
  resetPassword(email, password, password_confirmation, token) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/password/reset`, {
      email,
      password,
      password_confirmation,
      token,
    })
  },
  resetPasswordSms(username, password, password_confirmation, code) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/password/verify-code`, {
      username,
      password,
      password_confirmation,
      code,
    })
  },
}
